module.exports = __webpack_public_path__ + "img/login.774cdf49.jpg";